/* eslint-disable @next/next/no-img-element */

import Link from 'next/link'
import React, { FormEvent } from 'react'

import { OrganizationRegistry, Organizations } from '@/lib/config/organization'
import { Button, Form, Heading, Input, InputOTP, Label } from '@aw/ui'
import { UseMutationResult } from '@tanstack/react-query'
import { OlameeLogo } from '@/components/shared/olamee-logo'

interface TwoFactorUIFormProps {
    submit: (data: { [x: string]: string }) => void
    twoFARequest: UseMutationResult<any, any, any, unknown>
    formErrors: {
        message: string | undefined,
        errors: Record<string, string> | undefined
    }
}
function TwoFactorUI({ submit, twoFARequest, formErrors }: TwoFactorUIFormProps) {
    const [challengeKey, setChallengeKey] = React.useState('code')
    const [code, setCode] = React.useState('')

    const recovery = challengeKey !== 'code'

    const submitForm = (event: FormEvent) => {
        event.preventDefault()

        submit({ [challengeKey]: code })
    }
    const [TwoFactorCode, setTwoFactorCode] = React.useState('')

    const organization = Organizations[OrganizationRegistry.ABROADWORKS]


    React.useEffect(() => {
        if (TwoFactorCode.length === 6) {
            submit({ code: TwoFactorCode })
        }
    }, [TwoFactorCode])


    return (
        <div
            className="flex flex-col items-center gap-6 w-full "
        >
            {/* COMPANY LOGO */}
            <div className="flex w-full flex-col ">
                <div className="flex w-full select-none">

                    <div className="h-[3.5rem] w-auto">

                        <OlameeLogo className="h-full" />
                    </div>
                </div>
            </div>

            <Form.FormErrors state={formErrors} className="mb-4" />

            <form onSubmit={submitForm}>
                <div className="mb-4 text-sm text-gunmetal-300">
                    Please confirm access to your account by entering{' '}
                    {recovery ? 'one of your emergency recovery codes' : 'the authentication code provided by your authenticator application'}.
                </div>

                <div className="flex flex-col gap-4">
                    <Label htmlFor="code" required>
                        Two Factor {recovery ? 'Recovery' : 'Auth'} Code
                    </Label>
                    <div className='flex w-full justify-center'>

                        {recovery ? (
                            <Input
                                id="code"
                                type="text"
                                value={code}
                                placeholder={`Enter ${recovery ? 'recovery' : 'auth'} code`}
                                onChange={(event: React.ChangeEvent<HTMLInputElement> | null) => {
                                    if (event) {
                                        setCode(event.target.value)
                                    } else {
                                        setCode('')
                                    }
                                }}
                                autoFocus
                            />
                        ) : (
                            <InputOTP
                                maxLength={6}
                                value={TwoFactorCode}
                                onChange={(value) => {
                                    setTwoFactorCode(value)
                                }}
                            />
                        )}
                    </div>

                </div>

                <div className="mt-4 flex items-center justify-between">
                    <Button
                        size="sm"
                        color={"purple"}
                        variant={"secondary"}
                        onClick={() => {
                            setChallengeKey(currentState => (currentState === 'code' ? 'recovery_code' : 'code'))
                        }}>
                        Use {!recovery ? 'recovery' : 'auth'} code
                    </Button>

                    <Button type="submit"
                        color={"purple"}
                        disabled={!TwoFactorCode || TwoFactorCode.length < 6 || !code}
                        size="sm" variant={"primary"} loading={twoFARequest?.isPending} className="ml-3 flex justify-center gap-2 items-center">
                        Verify Code
                    </Button>

                </div>
            </form>
        </div>
    )
}

export default React.memo(TwoFactorUI)
